/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum UserRoles {
  Carrier = 'carrier',
  Consignee = 'consignee',
  Consignor = 'consignor',
  OrganizationAdmin = 'organization_admin',
  SiteAdmin = 'site_admin',
  RemoteConsignor = 'remote_consignor',
  RemoteConsignee = 'remote_consignee',
  RemoteCarrier = 'remote_carrier',
  SelfCheckin = 'self_checkin',
  ServiceProvider = 'service_provider'
}
